import React, { useState, useEffect } from 'react';
import Loader from './components/Loader'; // Import the Loader component
import Layout from './components/Layout'; // Import the Layout component
import { CartProvider } from './context/CartContext';
import { AuthProvider } from './context/AuthContext';
import { WishlistProvider } from './context/WishlistContext';
import { ToastManager } from './components/Toast';
import styled from 'styled-components';
import { Analytics } from "@vercel/analytics/react"

const App = () => {
  const [isLoading, setIsLoading] = useState(true);

  // Optimized loading - show content as soon as possible
  useEffect(() => {
    // Check if critical resources are loaded
    const checkResourcesLoaded = () => {
      // Check if fonts are loaded
      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(() => {
          setIsLoading(false);
        });
      } else {
        // Fallback for browsers that don't support document.fonts
        setTimeout(() => {
          setIsLoading(false);
        }, 500); // Minimal delay for basic resources
      }
    };

    // Start checking resources immediately
    if (document.readyState === 'complete') {
      checkResourcesLoaded();
    } else {
      window.addEventListener('load', checkResourcesLoaded);
      // Failsafe timeout
      const timer = setTimeout(() => {
        setIsLoading(false);
      }, 1000);

      return () => {
        window.removeEventListener('load', checkResourcesLoaded);
        clearTimeout(timer);
      };
    }
  }, []);

  return (
    <AuthProvider>
      <WishlistProvider>
        <CartProvider>
          <StyledApp>
            {isLoading ? (
              <LoaderContainer>
                <Loader /> {/* Show the loader during the 3 seconds */}
              </LoaderContainer>
            ) : (
              <Layout /> 
            )}
            <ToastManager />
            <Analytics />
          </StyledApp>
        </CartProvider>
      </WishlistProvider>
    </AuthProvider>
  );
};

const StyledApp = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh; /* Ensure the app takes full height */
  background-color: #f0f0f0;
`;

const LoaderContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  width: 100vw;
  background-color: #f0f0f0;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1000;
`;

export default App;